// @flow
export const TINDER_U_DROP_OUT = 'TinderU.DropOut';
export const TINDER_U_MANAGE = 'TinderU.Manage';
export const TINDER_U_VERIFIED = 'TinderU.Verified';
// export const TINDER_U_VIEW_INVITE = 'TinderU.ViewInvite';
